/*
  The bespoke form's one extra: company name and quantity appear only when the
  commission is for a company.
*/
import './capra-care.js';

customElements.whenDefined('capra-care-form').then(() => {
  for (const form of document.querySelectorAll('capra-care-form[data-intent="bespoke"]')) {
    const fields = form.querySelector('[data-company-fields]');
    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-care="audience"]')) fields.hidden = event.target.value !== 'company';
    });
  }
});
